// extracted by mini-css-extract-plugin
export default {"container":"On-z","ratingLayout":"Pn-z","ratingLabel":"Qn-z","nonInteractiveRatingLabel":"Rn-z"};